import { render, staticRenderFns } from "./seeLicenseApplysfzorgan.vue?vue&type=template&id=4803264c&scoped=true&"
import script from "./seeLicenseApplysfzorgan.vue?vue&type=script&lang=js&"
export * from "./seeLicenseApplysfzorgan.vue?vue&type=script&lang=js&"
import style0 from "./seeLicenseApplysfzorgan.vue?vue&type=style&index=0&id=4803264c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4803264c",
  null
  
)

export default component.exports